import { render, staticRenderFns } from "./ListActions.vue?vue&type=template&id=0b5203b0"
import script from "./ListActions.vue?vue&type=script&lang=js"
export * from "./ListActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports